import classNames from 'classnames';
import React, { Ref } from 'react';
import mergeRefs from 'react-merge-refs';

import { ExpandableInput } from '@eika/expandable-input';
import { Input, InputLabel } from '@eika/input';

import { FocusableHtmlElement, useFocusRef } from '../../sporsmalsflyt/hooks';
import { TextInputSize } from '../../types/generated-types';

import './input-text.scss';

export enum InputType {
    Text = 'text',
    Number = 'num',
    Telephone = 'tel',
    Email = 'email',
}

const inputTypeToInputMode = (inputType: InputType): 'text' | 'numeric' | 'tel' | 'email' => {
    switch (inputType) {
        case InputType.Text:
            return 'text';
        case InputType.Number:
            return 'numeric';
        case InputType.Telephone:
            return 'tel';
        case InputType.Email:
            return 'email';
        default:
            return 'text';
    }
};

const inputTypeToAutoComplete = (inputType: InputType): string => {
    switch (inputType) {
        case InputType.Telephone:
            return 'tel-national';
        case InputType.Email:
            return 'email';
        default:
            return 'off';
    }
};

interface Props {
    tittel: string;
    ingress?: string;
    verdi: string;
    feilmelding: string;
    isValid: boolean;
    onChange: (eventValue: string) => void;
    size: TextInputSize;
    type?: InputType;
    id: string;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
    placeholder?: string;
}

export const InputTekst = ({
    tittel,
    ingress,
    verdi,
    onChange,
    feilmelding,
    isValid,
    size,
    type = InputType.Text,
    id,
    focusOnMount,
    errorRef,
    placeholder,
}: Props) => {
    const textField = useFocusRef<HTMLInputElement & HTMLTextAreaElement>(focusOnMount);
    return (
        <InputLabel label={tittel} sublabel={ingress} htmlFor={id}>
            {size !== TextInputSize.Large ? (
                <div className={classNames('input-text-wrapper', `input-text__${size}`)}>
                    <Input
                        id={id}
                        type={type}
                        autoComplete={inputTypeToAutoComplete(type)}
                        inputMode={inputTypeToInputMode(type)}
                        value={verdi}
                        onInput={(event) => onChange(event.currentTarget.value)}
                        ref={mergeRefs([textField, errorRef])}
                        error={!isValid && feilmelding}
                        placeholder={placeholder}
                    />
                </div>
            ) : (
                <div className="textarea-wrapper">
                    <div className="input-group">
                        <ExpandableInput
                            className="form-control"
                            id={id}
                            value={verdi}
                            onChange={(event) => onChange(event.currentTarget.value)}
                            ref={mergeRefs([textField, errorRef])}
                            error={!isValid && feilmelding}
                        />
                    </div>
                </div>
            )}
        </InputLabel>
    );
};
